// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__BNZj5","dashboardTitle":"dashboard_dashboardTitle__HUuUu"};